/**
 * The single configured Supabase client for the whole app
 * (react-pwa-engineering skill 18 — never instantiate one inside a component).
 *
 * The anon key is public by design: it grants nothing on its own. Every row the app can
 * reach is decided by PostgreSQL RLS (spec v2 19).
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@pfo/database';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy apps/web/.env.example to ' +
      'apps/web/.env.local and fill it in (see README section 5).',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
